<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'App',
  mounted () {
    let Https = window.location.href
    console.log(Https)
      const params = {
        url: Https
      }
	  console.log(this.$api,"$api")
      this.$api.Login.getweixin(params).then(res => {
        if (res.code == 200) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,// 必填，签名
            jsApiList: ['onMenuShareAppMessage',],
           openTagList:['wx-open-launch-weapp','wx-open-launch-app']
          });
          wx.ready(() => {
            this.wxtitle = true
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          });
          wx.error((err) => {
            // this.$alert(JSON.stringify(err), '温馨报错', {
            //   confirmButtonText: '确定',
            // })
            console.log(err)
          })
        }

      }).catch((err)=>{
		// this.tips(err.msg)
	})
  }
}
</script>

<style>
.Launch {
	width: 46%;
	margin: 40px auto 40px;
}
uni-page-body,
	html,
	body {
		height: 100%;
		background-color: #EFEFEF;
	}

	img {
		width: 100%;
		height: 100%;
	}

	/* 单行超出隐藏 */
	.text_com {
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	/* 多行超出隐藏 */
	.work_font {
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	/* 消除滚动条 */
	::-webkit-scrollbar {
		width: 0;
		height: 0;
		color: transparent;
	}

	.puhui {
		font-family: puhui;
	}

	.display {
		display: flex;
	}

	.displayBetween {
		display: flex;
		justify-content: space-between;
	}

	.footer_temp {
		width: 100%;
		padding: 20px 24px;
		background: #fff;
		display: flex;
		justify-content: space-between;
		position: fixed;
		bottom: 0;
		box-sizing: border-box;
		z-index: 99;
	}

	.footer_btn {
		width: 265px;
		height: 42px;
		line-height: 42px;
		background: #FA5151;
		color: #fff;
		font-size: 16px;
		font-weight: 600;
		text-align: center;
		box-sizing: border-box;
		border-radius: 21px;
	}

	::v-deep .uicon-star-fill {
		color: #FFC300 !important
	}
</style>



// WEBPACK FOOTER //
// src/App.vue